import { mesasEntradaConstants } from "./constants";


const initialState = {
  abogadoExtrajudicial: "",
  abogadoJudicial: "",
  fechaInicial: "",
  filters: null,
  mesaExtrajudicial: null,
  mesaJudicial: null,
  mesaExterna: null,
};

export function mesasEntrada(state = initialState, action) {
  switch (action.type) {
  case mesasEntradaConstants.ABOGADO_EXTRAJUDICIAL:
    return {
      ...state,
      abogadoExtrajudicial: action.payload,
    };
  case mesasEntradaConstants.ABOGADO_JUDICIAL:
    return {
      ...state,
      abogadoJudicial: action.payload,
    };
  case mesasEntradaConstants.SAVE_FILTERS:
    return {
      ...state,
      filters: action.payload,
    };
  case mesasEntradaConstants.MESA_EXTRAJUDICIAL:
    return {
      ...state,
      mesaExtrajudicial: action.payload,
    };
  case mesasEntradaConstants.MESA_JUDICIAL:
    return {
      ...state,
      mesaJudicial: action.payload,
    };
  case mesasEntradaConstants.FECHA_INICIAL:
    return {
      ...state,
      fechaInicial: action.payload,
    };
  case mesasEntradaConstants.LIMPIAR_MESAS:
    return initialState;
  case mesasEntradaConstants.MESA_EXTERNA:
    return {
      ...state,
      mesaExterna: action.payload,
    };
  default:
    return state;
  }
}

